@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.paywall.paywall_ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.feature.paywall.paywall_ui.generated.resources/"

@delegate:ResourceContentHash(1_645_735_666)
internal val Res.drawable.ic_subtract: DrawableResource by lazy {
      DrawableResource("drawable:ic_subtract", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_subtract.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_subtract", Res.drawable.ic_subtract)
}
